<script setup>
import { useUserStore } from '@/stores/userStore'
import { areaCodeAPI, addAddressAPI, sendCodeAPI, addressListAPI, setDefaultaddressAPI, setAvatarAPI, editAddressAPI, getAddressInfoAPI, setUserAPI } from '@/apis/user'
import { onMounted, ref, reactive } from 'vue'
import { setshelvesFilterAPI } from '@/apis/pay'

import axios from 'axios'
import addressView from '@/components/addressView/index.vue'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const userStore = useUserStore()
const likeList = ref([])

const registerRef = ref()

const getLikeList = async () => {
    // limit: 4 表示拉去的数据数量
    // const res = await getLikeListAPI({ limit: 4 })
    // likeList.value = res.result
}
const rulesRegister = {
    email: [
        { required: true, message: t('login20'), trigger: 'blur' },
        { type: 'email', message: t('login21'), trigger: 'blur' },

    ],
    code: [
        { required: true, message: t('login22'), trigger: 'blur' },
        { min: 4, max: 4, message: t('login23'), trigger: 'blur' }
    ],
}
const state = reactive({
    //发送验证码
    text: t('login16'),
    loading: false,
    disabled: false,
    duration: 60,
    timer: null,
    Resettext: t('login16'),
    Resetloading: false,
    Resetdisabled: false,
    Resetduration: 60,
    Resettimer: null,
    default: {
        text: t('login16'),
        duration: 60
    },
    verifiedModel: false,
    areaCodeList: [],

    registerForm: {
        email: '',
        code: null,
    },
});
const formData = reactive({
    addressForm: {
        sur_name: '',
        name: '',
        mobile: '',
        country: '',
        province: '',
        city: '',
        area: '',
        zip_code: '',
        default: false,

    },
    userform: {
        nickname: '',
        mobile: '',
        email: '',
        password: '',
        balance: null,
        telegram: '',
        watchApp: '',
        introduce: ''
    }

})
const getUser = async () => {
    userStore.getUser()
    formData.userform = userStore.userInfo

}
const countdown = () => {

    state.disabled = true;

    state.timer && clearInterval(state.timer);

    state.timer = setInterval(() => {

        const tmp = state.duration--;
        state.text = `${tmp}s`;
        if (tmp <= 0) {
            clearInterval(state.timer);
            state.duration = state.default.duration;
            state.text = state.default.text;
            state.disabled = false;
        }

    }, 1000);

};
const registersend = () => {
    state.verifiedModel = false
    countdown()
    registerRef.value.validateField('mobile', async (valid) => {
        if (valid) {
            let data = {
                email: state.registerForm.email,
                type: 3,
            }
            const res = await sendCodeAPI(data)
            console.log(res)
            if (res.code == 0) {

                ElMessage({ type: 'success', message: t('login19') })
            } else {
                ElMessage({ type: 'error', message: res.message })
            }

        }
    })
};
const addressAll = ref([])
/**
 * 获取地址列表
 */
const addressList = async () => {
    const res = await addressListAPI()
    if (res.code == 0) {
        addressAll.value = res.data.list
        addressAll.value.forEach(address => {
            if (address.default == 1) {
                address.selected = true
            } else {
                address.selected = false
            }

        });
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
//设置默认地址
const selectAddress = async (id) => {

    const res = await setDefaultaddressAPI({ address_id: id })
    if (res.code == 0) {
        // 将所有地址的选中状态重置为未选中
        addressAll.value.forEach(address => {
            address.selected = false;
            if (address.id == id) {
                address.selected = true
            } else {
                address.selected = false
            }
        });
        addressList()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }


}
const dialogAddress = ref(false)
const editType = ref(1)//1 编辑 2 换绑
const modeltitle = ref(t('number16'))
const openModel = () => {
    infoId.value = ''
    modeltitle.value = t('number16');
    dialogAddress.value = true
}
const infoId = ref()
//获取地址详情
const getInfo = async (id) => {

    infoId.value = id
    modeltitle.value = t('number17')
    dialogAddress.value = true

}
const stateUser = ref(true)

const setUser = (e) => {
    if (e == 1 && !userStore.userInfo.email) {
        ElMessage({ type: 'error', message: t('setup589') })
        editType.value = 2
        stateUser.value = false
        return
    }
    editType.value = e
    stateUser.value = false

}
/**
 * 修改用户信息
 */
const submitUser = async () => {
    let data = {
        email: state.registerForm.email,
        code: state.registerForm.code
    }
    if (editType.value == 1) {
        data = {
            nickname: formData.userform.nickname,
            telegram: formData.userform.telegram,
            watchApp: formData.userform.watchApp,
            email: formData.userform.email,
            password: formData.userform.password,
            introduce: formData.userform.introduce

        }

    }
    const res = await setUserAPI(data)
    if (res.code == 0) {
        stateUser.value = true
        userStore.getUser()
        setTimeout(() => {
            formData.userform = userStore.userInfo
        }, 1000);
    } else {
        ElMessage({ type: 'error', message: res.message })
    }

}
const handleClose = () => {

    dialogAddress.value = false
    addressList()
}
// 上传前的检查
const beforeUpload = (file) => {
    // 检查文件类型
    const isValidType = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type)
    if (!isValidType) {
        ElMessage.error(t("number18"))
        return false
    }

    // 检查文件大小（小于10MB）
    const isLt10M = file.size / 1024 / 1024 < 10
    if (!isLt10M) {
        ElMessage.error(t('number19'))
        return false
    }

    return true
}
// 封面上传方法
const CoverCustomUpload = async (options) => {
    try {
        // 1. 获取文件扩展名
        const fileExt = options.file.name.split('.').pop()

        // 2. 调用后端接口获取预签名URL
        const { data: presignedData } = await setshelvesFilterAPI({
            fileExtension: fileExt,
            bucketName: 'shap-head-test'
        })

        // 3. 准备表单数据
        const formData = new FormData()
        // 添加后端返回的所有表单字段
        Object.entries(presignedData.formData).forEach(([key, value]) => {
            formData.append(key, value)
        })
        console.log(presignedData.formData)
        // 添加文件
        formData.append('file', options.file)

        // // 4. 执行上传
        const response = await axios.post(presignedData.url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        // // 5. 上传成功
        if (response.status === 204) {
            ElMessage.success(t("number20"))
            // 构建文件访问URL
            const fileUrl = `${presignedData.url}${presignedData.formData.key}`

            // 可以在这里处理上传成功后的逻辑，比如将fileUrl保存到表单中

            const res = await setAvatarAPI({ avatar: fileUrl })
            if (res.code == 0) {
                getUser()
            }

        }
    } catch (error) {
        ElMessage.error(error.message)
        throw error
    }
}
onMounted(() => {
    getUser();

    // addressList();
})

const addressCheck = ref()

</script>

<template>
    <div class="userINFO">
        <div class="home-overview">
            <!-- 用户信息 -->
            <div class="user-meta">
                <el-upload class="avatar-uploader" :limit="1" :http-request="CoverCustomUpload"
                    :before-upload="beforeUpload" :show-file-list="false">
                    <div class="avatar">
                        <img
                            :src="userStore.userInfo?.avatar || 'https://shopfile.51siteboost.com/shap-head-test/20250304/1741069084714129479.png'" />
                    </div>
                </el-upload>
                <div class="nickname">
                    <div class="name">
                        {{ userStore.userInfo?.nickname }}
                    </div>
                    <div class="Upload">
                        Upload profile picture
                    </div>
                    <!-- <span v-if="formData.userform.identity == 2"><svg-icon
                            icon-class="zuanshi" />
                    </span> -->
                </div>
            </div>
            <div class="item">
                <a href="javascript:;">
                    <div class="value">{{ userStore.userInfo?.balance }}</div>
                    <p>{{ $t("setup26") }}</p>
                </a>
                <a href="javascript:;">
                    <div class="value">{{ formData.userform.fansNum }}</div>
                    <p>{{ $t('home6') }}</p>
                </a>
                <a href="javascript:;">
                    <div class="value">{{ formData.userform.followGoodsNum }}</div>
                    <p>{{ $t('number22') }}</p>
                </a>
                <a href="javascript:;">
                    <div class="value">{{ formData.userform.followPersonNum }}</div>
                    <p>{{ $t('home7') }}</p>
                </a>
            </div>
        </div>

        <div class="like-container">
            <div class="home-panel">
                <div class="header">
                    <div>{{ $t('number23') }}</div>
                </div>
                <div class="userform" v-if="editType == 2 && !stateUser">
                    <el-form ref="registerRef" :model="state.registerForm" label-width="auto" :rules="rulesRegister">
                        <el-form-item :label="t('login7')" prop="email">
                            <el-input v-model="state.registerForm.email" style="width: 360px;" />
                        </el-form-item>
                        <el-form-item prop="code" :label="t('login8')" class="form-item">
                            <el-input class="reset-input" v-model="state.registerForm.code" :placeholder="$t('login9')">
                                <template #append>
                                    <el-button :loading="state.loading" :disabled="state.disabled"
                                        @click="registersend()">
                                        {{ state.text }}
                                    </el-button>
                                </template>
                            </el-input>
                        </el-form-item>

                        <!-- <el-form-item :label="t('number26')">
                            <el-input v-model="formData.userform.nickname" :disabled="stateUser" style="width: 360px;"/>
                        </el-form-item> -->

                    </el-form>
                </div>
                <div class="userform" v-else>
                    <el-form :model="formData.userform" label-width="auto">
                        <el-form-item :label="t('login7')">
                            <el-input v-model="formData.userform.email" disabled style="width: 360px;" />
                        </el-form-item>
                        <el-form-item :label="t('number26')">
                            <el-input v-model="formData.userform.nickname" :disabled="stateUser"
                                style="width: 360px;" />
                        </el-form-item>
                        <el-form-item :label="t('login10')">
                            <el-input v-model="formData.userform.password" type="password" show-password
                                :disabled="stateUser" style="width: 360px;" />
                        </el-form-item>
                        <el-form-item label="telegram">
                            <el-input v-model="formData.userform.telegram" :disabled="stateUser"
                                style="width: 360px;" />
                        </el-form-item>
                        <el-form-item label="watchApp">
                            <el-input v-model="formData.userform.watchApp" :disabled="stateUser"
                                style="width: 360px;" />
                        </el-form-item>
                        <el-form-item :label="t('number27')">
                            <el-input type="textarea" :rows="4" v-model="formData.userform.introduce"
                                :disabled="stateUser" style="width: 360px;" />
                        </el-form-item>
                    </el-form>
                </div>
                <div class="but">
                    <div v-if="!stateUser" @click="stateUser = true" class="userbut back">{{ $t('setup500') }}</div>
                    <div v-if="stateUser == true && !userStore.userInfo.email" @click="setUser(2)" class="userbut">
                        {{$t('setup588')}}
                    </div>
                    <div v-if="!stateUser||!userStore.userInfo.email" style="width: 20px;"> </div>

                    <div v-if="stateUser == true && userStore.userInfo.email" @click="setUser(1)" class="userbut">{{
                        $t('number24') }}
                    </div>
                    <div v-else @click="submitUser()" class="userbut">{{ $t('number25') }}</div>
                    <!-- <div v-else-if="!userStore.userInfo.email&&editType==2" @click="submitUser()" class="userbut">保存</div> -->

                </div>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">
.userINFO {
    background: #FFFFFF;
    height: 100%;
    border-radius: 8px;
}

.home-overview {
    height: 120px;
    background: url(@/assets/images/center-bg.png) no-repeat center / cover;
    display: flex;

    .user-meta {
        // flex: 1;
        display: flex;
        // align-items: center;
        padding: 20px 8px 20px 20px;

        .avatar {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;
            margin-left: 20px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                background: none
            }
        }

        .nickname {
            padding: 14px 0 12px 8px;

            .name {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #11192D;
                line-height: 21px;
                text-align: left;
                font-style: normal;
                padding-bottom: 9px;
            }

            .Upload {
                width: 154px;
                height: 24px;
                background: #FFEADA;
                border-radius: 4px;
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #DE7777;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            // padding-left:8px;

        }
    }

    .item {
        padding: 0 37px 0 69px;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-around;

        &:first-child {
            border-right: 1px solid #f4f4f4;
        }

        .value {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 16px;
            color: #FC3938;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            padding-bottom: 10px;
        }

        a {
            display: flex;
            flex-direction: column;
            align-items: center;
            // color: #11192D;
            // font-size: 16px;
            // text-align: center;

            // .iconfont {
            //     font-size: 32px;
            // }

            p {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #11192D;
                line-height: 14px;
                text-align: left;
                font-style: normal;
            }
        }
    }

    .like-container {

        // margin-top: 20px;
        // border-radius: 4px;
        // background-color: #fff;
        .header {
            font-size: 18px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #11192D;
            line-height: 18px;
            text-align: left;
            font-style: normal;
        }



    }
}

.userform {
    display: flex;
    justify-content: flex-end;
    padding-top: 40px;
    padding-right: 235px;

}

.addressList {
    // padding: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-auto-rows: 90px;
    grid-gap: 20px;
    padding: 20px 0;

    .addressItem {
        width: 300px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #f5f5f5;
        padding: 20px 20px;
        border-radius: 36px;


        .Content {
            font-size: 14px;
            line-height: 21px;
            width: 150px;

            .text {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }

            .Contacts {
                display: flex;


            }

        }

        .Operation {
            display: flex;
            flex-direction: column;
            align-items: center;

            .Default {
                margin-top: 15px;
                background-color: rgba(241, 133, 55, 0.1411764706);
                font-size: 11px;
                color: #e26237;
                width: 45px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 37px;
                padding: 0 5px;
            }
        }
    }
}

.home-panel {
    background-color: #fff;
    padding: 0 20px 20px 20px;
    margin-top: 30px;
    // height: 400px;

    .header {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #11192D;
        line-height: 18px;
        text-align: left;
        font-style: normal;
    }

    .goods-list {
        display: flex;
        justify-content: space-around;
    }

    .but {
        padding-top: 10px;
        display: flex;
        justify-content: center;

        .userbut {
            height: 40px;
            width: 150px;
            background: #FF9845;
            border-radius: 20px;
            // padding: 10px 51px 10px 51px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 19px;
            text-align: left;
            font-style: normal;

        }

        .back {
            background: gray;
        }
    }
}
</style>